const riskStatusOptions = [
  {
    value: "pass",
    label: "Pass",
  },
  {
    value: "refer",
    label: "Refer",
  },
  {
    value: "fail",
    label: "Fail",
  },
  {
    value: "pending",
    label: "Pending",
  },
];

const passFailOptions = [
  {
    value: "pass",
    label: "Pass",
  },
  {
    value: "fail",
    label: "Fail",
  },
  {
    value: "pending",
    label: "Pending",
  },
];

const applicationConfig = { riskStatusOptions, passFailOptions };
export default applicationConfig;
